<div class="shop-payroll-settings-component-container page-root-container">
    <div class="page-header">
        <div class="page-title">
            <img class="icon" src="assets/images/menu/svg/shop-payroll.svg">
            <span class="title">Shop Payroll Settings</span>
        </div>
        <div class="page-actions">
            @if(permission.can_export || permission.can_execute){
            <button mat-button color="accent" class="btn-export" (click)="exportClicked()" [disabled]="IsDownloading">
                <img class="download-icon"
                    [src]="IsDownloading ? 'assets/images/animated/download/download-anim.svg' : 'assets/images/animated/download/download-no-anim.svg'">
                Export
            </button>
            }
        </div>
    </div>

    <div class="data-container">
        <app-loader [show]="isLoading"></app-loader>

        <app-search-filter #searchFilter [pagingData]="pagingData" [pageSizeOptions]="[5,10,20,50,100]"
            [filter]="filter" (page)="onePageEvent($event)" (onApply)="onFilterApplied($event)" [hidePageSize]="true">
        </app-search-filter>

        <section tabindex="0" class="table-container">
            <table matSort mat-table [dataSource]="dataSource" (matSortChange)="sortData($event)">
                <ng-container matColumnDef="item">
                    <th mat-header-cell *matHeaderCellDef class="item-header">#</th>
                    <td mat-cell *matCellDef="let row; let i = index" class="item-column">
                        {{ (pagingData.pageIndex*pagingData.pageSize) + i + 1 }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="code">
                    <th mat-sort-header="code" mat-header-cell style="width: 80px;" *matHeaderCellDef>Code</th>
                    <td mat-cell *matCellDef="let row" style="width: 80px;">{{ row.code }}</td>
                </ng-container>

                <ng-container matColumnDef="name">
                    <th mat-sort-header="name" mat-header-cell *matHeaderCellDef>Name</th>
                    <td mat-cell *matCellDef="let row">{{ row.name }}</td>
                </ng-container>

                <ng-container matColumnDef="group_code">
                    <th mat-sort-header="group_code" mat-header-cell *matHeaderCellDef>Group</th>
                    <td mat-cell *matCellDef="let row">{{ row.group_code }}</td>
                </ng-container>

                <ng-container matColumnDef="group_name">
                    <th mat-sort-header="group_name" mat-header-cell *matHeaderCellDef>Group Name</th>
                    <td mat-cell *matCellDef="let row">{{ row.group_name }}</td>
                </ng-container>

                <ng-container matColumnDef="cost_code">
                    <th mat-sort-header="cost_code" mat-header-cell *matHeaderCellDef>Cost Code</th>
                    <td mat-cell *matCellDef="let row">{{ row.cost_code }}</td>
                </ng-container>

                <ng-container matColumnDef="action" stickyEnd>
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell class="row-menu-btn" style="width:50px" *matCellDef="let rowItem">
                        <a mat-icon-button class="row-menu-btn" [matMenuTriggerFor]="rowMenu"
                            (click)="onRowSelected(rowItem);$event.stopPropagation();">
                            <mat-icon>more_vert</mat-icon>
                        </a>
                        <mat-menu #rowMenu>
                            @if(permission.can_edit){
                            <button mat-menu-item (click)="onEdit(rowItem)">Edit</button>
                            }@else{
                            <button mat-menu-item (click)="onEdit(rowItem)">View</button>
                            }
                        </mat-menu>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row class="table-element-row" *matRowDef="let row; columns: displayedColumns;"
                    (click)="onRowSelected(row)" (dblclick)="onEdit(row)"
                    [ngClass]="{'row-selected': row.shop_id === selectedItem?.shop_id}">
                </tr>
            </table>
        </section>

        @if(pagingData.length<=0){ <div class="no-data-container">
            <img src="assets/images/no-data.png">
            <span class="no-data-info">No data found. Please remove or redefine the filters if any.</span>
    </div>
    }
</div>
</div>